import React from 'react'
import { RouteConstants } from '../../setup/routeConstants'
import { ACCESS_USER_DETAIL_PAGE } from '../../auth/policies'
import LazyProtectedRoute from '../LazyProtectedRoute'

const UserPage = React.lazy(() => import('../../components/Users/User'))

export default {
	path: RouteConstants.users.user.path,
	element: (
		<LazyProtectedRoute
			requiredPolicies={[ACCESS_USER_DETAIL_PAGE]}
			component={<UserPage />} 
		/>
	),
}